import React, { useState } from 'react';
import { Search, Plus, MoreVertical, Filter } from 'lucide-react';
import { tenants } from '../../data/mockData';
interface TenantListProps {
  onNavigate: (page: string, id?: string) => void;
}
export function TenantList({
  onNavigate
}: TenantListProps) {
  const [searchTerm, setSearchTerm] = useState('');
  const filteredTenants = tenants.filter(t => t.name.toLowerCase().includes(searchTerm.toLowerCase()) || t.league.toLowerCase().includes(searchTerm.toLowerCase()));
  return <div className="space-y-6" data-id="element-185">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4" data-id="element-186">
        <div className="relative w-full sm:w-96" data-id="element-187">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={18} data-id="element-188" />
          <input type="text" placeholder="Tenants suchen..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full pl-10 pr-4 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:border-emerald-500 focus:ring-1 focus:ring-emerald-500 outline-none" data-id="element-189" />
        </div>
        <div className="flex items-center gap-3 w-full sm:w-auto" data-id="element-190">
          <button className="flex items-center gap-2 px-4 py-2 bg-white border border-slate-200 rounded-lg text-sm font-medium text-slate-700 hover:bg-slate-50 transition-colors" data-id="element-191">
            <Filter size={16} data-id="element-192" />
            Filter
          </button>
          <button className="flex items-center gap-2 px-4 py-2 bg-emerald-500 text-white rounded-lg text-sm font-medium hover:bg-emerald-600 transition-colors shadow-sm" data-id="element-193">
            <Plus size={16} data-id="element-194" />
            Neuen Tenant
          </button>
        </div>
      </div>

      <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden" data-id="element-195">
        <div className="overflow-x-auto" data-id="element-196">
          <table className="w-full text-left border-collapse" data-id="element-197">
            <thead data-id="element-198">
              <tr className="bg-slate-50 border-b border-slate-200 text-xs uppercase tracking-wider text-slate-500 font-semibold" data-id="element-199">
                <th className="px-6 py-4" data-id="element-200">Club</th>
                <th className="px-6 py-4" data-id="element-201">Liga</th>
                <th className="px-6 py-4 text-right" data-id="element-202">Members</th>
                <th className="px-6 py-4 text-right" data-id="element-203">Companies</th>
                <th className="px-6 py-4 text-right" data-id="element-204">Events</th>
                <th className="px-6 py-4" data-id="element-205">Status</th>
                <th className="px-6 py-4" data-id="element-206">Erstellt am</th>
                <th className="px-6 py-4" data-id="element-207"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-208">
              {filteredTenants.map(tenant => <tr key={tenant.id} onClick={() => onNavigate('tenant-detail', tenant.id)} className="hover:bg-slate-50 cursor-pointer transition-colors group" data-id="element-209">
                  <td className="px-6 py-4" data-id="element-210">
                    <div className="flex items-center gap-3" data-id="element-211">
                      <div className="w-8 h-8 rounded-full flex items-center justify-center text-sm shadow-sm" style={{
                    backgroundColor: tenant.primaryColor
                  }} data-id="element-212">
                        {tenant.logo}
                      </div>
                      <span className="font-bold text-slate-900 group-hover:text-emerald-600 transition-colors" data-id="element-213">
                        {tenant.name}
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4 text-sm text-slate-600" data-id="element-214">
                    {tenant.league}
                  </td>
                  <td className="px-6 py-4 text-sm text-slate-900 font-medium text-right" data-id="element-215">
                    {tenant.memberCount}
                  </td>
                  <td className="px-6 py-4 text-sm text-slate-900 font-medium text-right" data-id="element-216">
                    {tenant.companyCount}
                  </td>
                  <td className="px-6 py-4 text-sm text-slate-900 font-medium text-right" data-id="element-217">
                    {tenant.eventCount}
                  </td>
                  <td className="px-6 py-4" data-id="element-218">
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${tenant.status === 'active' ? 'bg-green-100 text-green-800' : 'bg-slate-100 text-slate-800'}`} data-id="element-219">
                      {tenant.status === 'active' ? 'Aktiv' : 'Inaktiv'}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-sm text-slate-500" data-id="element-220">
                    {new Date(tenant.createdAt).toLocaleDateString('de-DE')}
                  </td>
                  <td className="px-6 py-4 text-right" data-id="element-221">
                    <button className="text-slate-400 hover:text-slate-600 p-1 rounded-md hover:bg-slate-200 transition-colors" onClick={e => e.stopPropagation()} data-id="element-222">
                      <MoreVertical size={18} data-id="element-223" />
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
        {filteredTenants.length === 0 && <div className="p-12 text-center text-slate-500" data-id="element-224">
            Keine Tenants gefunden.
          </div>}
      </div>
    </div>;
}